export default {
      id: "icon-logo-usage",
      viewBox: "0 0 71 71",
      url: __webpack_public_path__ + "img/icons.125b0740.svg#icon-logo",
      toString: function () {
        return this.url;
      }
    }